export interface Medium {
  _id: string;
  title?: string;
  subtitle?: string;
  category?: MediumCategory;
  format: MediumFormat;
  emoji?: MediumEmoji;
  mediumUrl: string;
  mediumThumbnailUrl?: string;
  printPieceNumber?: string;
  dateOfExpiry?: string;
  ratingAgency?: MediumRatingAgency;
  product?: MediumProduct;
}

export enum MediumCategory {
  BEDARFSERMITTLUNG = 'Bedarfsermittlung',
  BROSCHUERE = 'Broschüre',
  ERKLAERVIDEO = 'Erklärvideo',
  FLYER = 'Flyer',
  FONDSANGEBOT = 'Fondsangebot',
  HIGHLIGHTS = 'Highlights',
  LEISTUNGSUEBERSICHT = 'Leistungsübersicht',
  LEISTUNGSVERGLEICH = 'Leistungsvergleich',
  ONLINEABSCHLUSS = 'Onlineabschluss',
  PRODUKTUEBERSICHT = 'Produktübersicht',
  PRODUKTVERGLEICH = 'Produktvergleich',
  RECHENBEISPIEL = 'Rechenbeispiel',
  SIEGEL = 'Siegel',
  TARIFBESONDERHEITEN = 'Tarifbesonderheiten',
  WICHTIGE_VERSICHERUNGSINFO = 'Wichtige Versicherungsinformation'
}

export enum MediumFormat {
  AUSZEICHNUNG = 'Auszeichnung',
  DOKUMENT = 'Dokument',
  VIDEO = 'Video',
  WEBSEITE = 'Webseite'
}

export enum MediumEmoji {
  STERN = '⭐',
  CHECKMARK = '✅',
  GLUEHBIRNE = '💡',
  TV = '📺',
  TROPHY = '🏆',
  LUPE = '🔍',
  RECHENBEISPIEL = '🧮',
  WARENKORB = '🛒'
}

export enum MediumProduct {
  KEINE_ANGABE = '',
  BERUFSUNFAEHIGKEIT = 'Berufsunfähigkeit',
  FAHRRAD_EBIKE = 'Fahrrad-/E-Bike',
  FONDSRENTE = 'Fondsrente',
  GLAS = 'Glas',
  HAUSRAT = 'Hausrat',
  KFZ = 'Kfz',
  KISS = 'KISS',
  KRANKENTAGEGELD = 'Krankentagegeld',
  KRANKENVERSICHERUNG = 'Krankenversicherung',
  PRIVATHAFTPFLICHT = 'Privathaftpflicht',
  PRIVATRENTE_INVEST = 'PrivatRente Invest',
  RECHTSSCHUTZ = 'Rechtsschutz',
  TAGEGELDVERSICHERUNG = 'Tagegeldversicherungen',
  TIERHALTERHAFTPFLICHT = 'Tierhalterhaftpflicht',
  TIERVERSICHERUNG = 'Tierversicherung',
  UNFALLVERSICHERUNG = 'Unfallversicherung',
  WONGEBAEUDE = 'Wohngebäude',
  ZAHNVERSICHERUNG = 'Zahnversicherung',
  ZUSATZVERSICHERUNG = 'Zusatzversicherung'
}

export enum MediumRatingAgency {
  FINANZTEST = 'Finanztest',
  FOCUS_MONEY = 'FOCUS-MONEY',
  FRANKE_BORNBERG = 'Franke und Bornberg',
  LEVELNINE = 'Levelnine',
  MORGEN_MORGEN = 'Morgen & Morgen'
}